import { FC, ReactNode } from "react";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import CustomDocumentPreviewModal from "@/src/components/CustomUtils/CustomDocumentPreviewModal/CustomDocumentPreviewModal";
import { AODSvgExport } from "@/src/svg/admissionOfficePage/AOPSvgExport";

export interface AOPGeneratedDocumentToolbarProps {
  isGenerated: boolean;
  generatedPdfUrl: string | null;
  isGeneratedPdfPreviewOpen: boolean;
  setIsGeneratedPdfPreviewOpen: (open: boolean) => void;
  generatedPreviewTitle: string;
  onDownload: () => void;
  onApprove: () => void;
  onReject: () => void;
  previewButton?: ReactNode;
  generateButton: ReactNode;
  refreshButton?: ReactNode;
  /** Extra controls after the eye button row (e.g. Request letter “With Print”). */
  trailingSlot?: ReactNode;
}

/**
 * Shared Admissions Office toolbar: Preview / Generate / Download + eye (PDF modal with Approve/Reject).
 */
const AOPGeneratedDocumentToolbar: FC<AOPGeneratedDocumentToolbarProps> = ({
  isGenerated,
  generatedPdfUrl,
  isGeneratedPdfPreviewOpen,
  setIsGeneratedPdfPreviewOpen,
  generatedPreviewTitle,
  onDownload,
  onApprove,
  onReject,
  previewButton,
  generateButton,
  refreshButton,
  trailingSlot,
}) => (
  <>
    <div className="form-group-buttons">
      <div className="form-group-buttons-pack">
        {previewButton}
        {generateButton}
        <BtnDefault onClick={onDownload} disabled={!isGenerated || !generatedPdfUrl}>
          <p>Download PDF</p>
          <AODSvgExport.DownloadSvg />
        </BtnDefault>
      </div>
      <div className="form-group-buttons-pack">
        <BtnDefault
          onlyIcon={true}
          reverse={true}
          disabled={!isGenerated || !generatedPdfUrl}
          onClick={() => setIsGeneratedPdfPreviewOpen(true)}
        >
          <AODSvgExport.PreviewSvg />
        </BtnDefault>
        {refreshButton ?? (
          <div className="form-group-buttons-refresh" onClick={() => window.location.reload()}>
            <BtnDefault onlyIcon={true}>
              <AODSvgExport.RefreshSvg />
            </BtnDefault>
          </div>
        )}
      </div>
      {trailingSlot}
    </div>

    <CustomDocumentPreviewModal
      isOpen={isGeneratedPdfPreviewOpen}
      documentUrl={generatedPdfUrl}
      onApprove={onApprove}
      onReject={onReject}
      onClose={() => setIsGeneratedPdfPreviewOpen(false)}
      title={generatedPreviewTitle}
      fileExtension="pdf"
    />
  </>
);

export default AOPGeneratedDocumentToolbar;
